export const orderStatus = {
    onTime: "On Time",
    runningLate: "Running Late",
    updated: "Updated",
    notUpdated: "Not Updated",
    noSignal: "No Signal"
}